import React from "react";
import { motion } from "framer-motion";
import { MapPin, Users, Heart, BookOpen } from "lucide-react";

const AboutSection = () => {
  const features = [
    {
      icon: MapPin,
      title: "Vendndodhja",
      description: "Në zemër të lagjes Ali Demi, Tiranë",
    },
    {
      icon: Users,
      title: "Komuniteti",
      description: "Një bashkësi e fortë e besimtareve myslimanë",
    },
    {
      icon: Heart,
      title: "Shërbime",
      description: "Namaz, ligjërata, aktivitete dhe mbështetje sociale",
    },
    {
      icon: BookOpen,
      title: "Edukim",
      description: "Mësim i Kur'anit dhe njohurive islame",
    },
  ];

  return (
    <section
      id="rreth-nesh"
      className="py-16 md:py-24 bg-background"
      data-testid="about-section"
    >
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-4">
            Rreth Nesh
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Xhamia e Ali Demit është një vend përkulljeje, paqeje dhe komuniteti
            në zemër të Tiranës
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="order-2 lg:order-1"
          >
            <div className="prose prose-lg max-w-none">
              <p className="text-foreground leading-relaxed mb-4">
                Xhamia jonë shërben si një qendër shërjrore dhe komunitare për
                banorët e lagjes Ali Demi dhe rrethinasë. Me një histori të
                pasur dhe një komunitet të gjallë, ne jemi të përkushtuar në
                ofrimin e një ambienti mirësëardhës për të gjithë.
              </p>
              <p className="text-foreground leading-relaxed mb-4">
                Përtej namazeve të përditshmeve, xhamia organizon ligjërata
                fetare, mësime të Kur'anit, aktivitete për të rinj, dhe programe
                mbështetëse për familjet në nevojë. Misioni ynë është të
                kultivojmë një komunitet të fortë, të bazuar në vlerat islame të
                dashurisë, respektit dhe solidaritetit.
              </p>
              <p className="text-foreground leading-relaxed">
                Çdo musliman dhe muslimane janë të mirëpritur të na bashkohen në
                lutje, të marrin pjesë në aktivitetet tona, dhe të jenë pjesë e
                kësaj familjeje shërjrore të bukur.
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="order-1 lg:order-2"
          >
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="/my-mosque-icon.png"
                alt="Komuniteti i xhamisë"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/60 to-transparent" />
            </div>
          </motion.div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-card rounded-2xl p-6 shadow-md hover:shadow-xl transition-shadow text-center"
                data-testid={`feature-card-${index}`}
              >
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Icon className="w-8 h-8 text-primary" />
                </div>
                <h3 className="font-heading font-semibold text-lg mb-2">
                  {feature.title}
                </h3>
                <p className="text-sm text-muted-foreground">
                  {feature.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
